// initialCards.js
// Default cards and decks shown to new users on first load.
// Edit this file to update starter content without touching App.js.
// Icons use Google's favicon CDN — same source as the in-app "Auto" button.

const FAV = (domain) => `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;

export const INITIAL_DECKS = [
  {
    id: 'deck-daily',
    name: 'Daily Use',
    description: 'Sites you visit every day',
    color: 'bg-sky-500',
    createdTime: new Date().toISOString(),
    createdBy: null
  },
  {
    id: 'deck-design',
    name: 'Graphic Design',
    description: 'Tools for artists and designers',
    color: 'bg-pink-500',
    createdTime: new Date().toISOString(),
    createdBy: null
  },
  {
    id: 'deck-education',
    name: 'Education & Learning',
    description: 'Courses, study tools, and learning platforms',
    color: 'bg-teal-500',
    createdTime: new Date().toISOString(),
    createdBy: null
  },
  {
    id: 'deck-useful',
    name: 'Useful Sites',
    description: 'Handy tools for everyday tasks',
    color: 'bg-emerald-500',
    createdTime: new Date().toISOString(),
    createdBy: null
  }
];

const INITIAL_CARDS = [
  // ── Daily Use ──────────────────────────────────────────────────────────────
  {
    id: '1', title: 'YouTube',
    description: 'Video sharing and streaming platform',
    url: 'https://youtube.com',
    dataType: 'html', tags: ['video', 'social media', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('youtube.com'), status: 'active', deckId: 'deck-daily'
  },
  {
    id: '2', title: 'Facebook',
    description: 'Social networking platform for connecting with friends and family',
    url: 'https://facebook.com',
    dataType: 'html', tags: ['social media', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('facebook.com'), status: 'active', deckId: 'deck-daily'
  },
  {
    id: '3', title: 'Wikipedia',
    description: 'Free online encyclopedia — the global starting point for research',
    url: 'https://wikipedia.com',
    dataType: 'html', tags: ['reference', 'encyclopedia', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('wikipedia.org'), status: 'active', deckId: 'deck-daily'
  },
  {
    id: '4', title: 'Spotify',
    description: 'Music streaming service for playlists, podcasts, and discovery',
    url: 'https://spotify.com',
    dataType: 'html', tags: ['music', 'audio editor', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('spotify.com'), status: 'active', deckId: 'deck-daily'
  },

  // ── Graphic Design ─────────────────────────────────────────────────────────
  {
    id: '5', title: 'Maneken',
    description: '3D posing tool for artists and designers',
    url: 'https://maneken.app/',
    dataType: 'html', tags: ['design app', 'ui', 'image generation'],
    createdTime: new Date().toISOString(),
    icon: FAV('maneken.app'), status: 'active', deckId: 'deck-design'
  },

  // ── Education & Learning ───────────────────────────────────────────────────
  {
    id: '6', title: 'Coursera',
    description: 'Online learning platform for courses and degrees',
    url: 'https://coursera.org',
    dataType: 'html', tags: ['education', 'online school', 'learning'],
    createdTime: new Date().toISOString(),
    icon: FAV('coursera.org'), status: 'active', deckId: 'deck-education'
  },
  {
    id: '7', title: 'Udemy',
    description: 'Global marketplace for learning and instruction',
    url: 'https://udemy.com',
    dataType: 'html', tags: ['education', 'online school', 'tutorial'],
    createdTime: new Date().toISOString(),
    icon: FAV('udemy.com'), status: 'active', deckId: 'deck-education'
  },
  {
    id: '8', title: 'OpenLearn',
    description: 'Free learning from The Open University',
    url: 'https://www.open.edu/openlearn/',
    dataType: 'html', tags: ['education', 'reference', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('open.edu'), status: 'active', deckId: 'deck-education'
  },
  {
    id: '9', title: 'Coursology',
    description: 'AI-powered study assistant and homework helper',
    url: 'https://coursology.com/',
    dataType: 'html', tags: ['education', 'AI', 'note taking'],
    createdTime: new Date().toISOString(),
    icon: FAV('coursology.com'), status: 'active', deckId: 'deck-education'
  },
  {
    id: '10', title: 'Jamie',
    description: 'AI meeting assistant for automated summaries',
    url: 'https://www.meetjamie.ai/',
    dataType: 'html', tags: ['AI', 'automation', 'note taking'],
    createdTime: new Date().toISOString(),
    icon: FAV('meetjamie.ai'), status: 'active', deckId: 'deck-education'
  },
  {
    id: '11', title: 'Otter.ai',
    description: 'AI transcription and meeting notes service',
    url: 'https://otter.ai/',
    dataType: 'html', tags: ['AI', 'automation', 'note taking'],
    createdTime: new Date().toISOString(),
    icon: FAV('otter.ai'), status: 'active', deckId: 'deck-education'
  },
  {
    id: '12', title: 'TheaStudy',
    description: 'Study resources and educational tools',
    url: 'https://www.theastudy.com/',
    dataType: 'html', tags: ['education', 'reference', 'tutorial'],
    createdTime: new Date().toISOString(),
    icon: FAV('theastudy.com'), status: 'active', deckId: 'deck-education'
  },
  {
    id: '13', title: 'Class Central',
    description: 'Search engine for free online courses',
    url: 'https://classcentral.com',
    dataType: 'html', tags: ['education', 'reference', 'learning'],
    createdTime: new Date().toISOString(),
    icon: FAV('classcentral.com'), status: 'active', deckId: 'deck-education'
  },

  // ── Useful Sites ───────────────────────────────────────────────────────────
  {
    id: '14', title: 'PairDrop',
    description: 'Local file sharing in your browser — no account needed',
    url: 'https://pairdrop.net/',
    dataType: 'html', tags: ['api', 'self-host', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('pairdrop.net'), status: 'active', deckId: 'deck-useful'
  },
  {
    id: '15', title: 'Vert',
    description: 'Simple and fast file conversion tool',
    url: 'https://vert.sh',
    dataType: 'html', tags: ['software', 'programs', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('vert.sh'), status: 'active', deckId: 'deck-useful'
  },
  {
    id: '16', title: 'BentoPDF',
    description: 'Suite of easy-to-use PDF tools in the browser',
    url: 'https://bentopdf.com',
    dataType: 'html', tags: ['software', 'documentation', 'daily use'],
    createdTime: new Date().toISOString(),
    icon: FAV('bentopdf.com'), status: 'active', deckId: 'deck-useful'
  },
  {
    id: '17', title: 'FMHY Video',
    description: 'Comprehensive video resources and tools guide',
    url: 'https://fmhy.net/video',
    dataType: 'html', tags: ['video', 'reference', 'tips'],
    createdTime: new Date().toISOString(),
    icon: FAV('fmhy.net'), status: 'active', deckId: 'deck-useful'
  }
];

export default INITIAL_CARDS;
